import React, { useCallback, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { parseQuery, stringifyQuery } from '../../utils/query';
import RouteDetailContainer from './components/RouteDetailContainer';
import { controlLockedByNotification } from '../../store/reducers/route';
import {
  getRouteLockedBy,
  isRouteStatusSuitableForReConsolidation,
} from '../../store/selectors/route';
import { setScrollToRoute } from '../../store/reducers/routes';
import { getSuitableStopsForReConsolidation } from '../../models/route';

const RouteDetail = ({ routeDetail }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const routeLockedBy = useSelector(getRouteLockedBy);
  const isCurrentStatusSuitableForReConsolidation = useSelector(
    isRouteStatusSuitableForReConsolidation
  );

  const availableForReConsolidation = useMemo(() => {
    if (!isCurrentStatusSuitableForReConsolidation) {
      return false;
    }

    const suitableStops = getSuitableStopsForReConsolidation(routeDetail.stop);
    const hasStops = !!Object.keys(suitableStops).length;

    return hasStops ? suitableStops : false;
  }, [isCurrentStatusSuitableForReConsolidation, routeDetail.stop]);

  useEffect(() => {
    dispatch(controlLockedByNotification(routeLockedBy));
  }, [routeLockedBy, dispatch]);

  const handleBackClick = useCallback(async () => {
    // eslint-disable-next-line no-unused-vars
    const { detailVisible, routeId, ...newQuery } = parseQuery(location.search);
    dispatch(setScrollToRoute(routeId));
    navigate({
      search: stringifyQuery({ ...newQuery }),
    });
  }, [location.search, navigate, dispatch]);

  return (
    <RouteDetailContainer
      route={routeDetail}
      handleBackClick={handleBackClick}
      availableForReConsolidation={availableForReConsolidation}
    />
  );
};

export default RouteDetail;
